// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__oFka-","header":"styles_header__KDqVb","overviewHeader":"styles_overviewHeader__1_D23","optionsRemition":"styles_optionsRemition__17R4P"};